export const TOGGLE_BUTTON = {
  edit: "Edit information",
  save: "Save changes",
};

export const HEADINGS = {
  personalInfo: "Personal Information",
  roles: "Roles",
  notification: "Notification Preferences",
};

export const BATCH_DESCRIPTIONS =
  "We will send you a daily summary for this notification, at the time of your choice.";

export const BATCH_HOURS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const BATCH_MERIDIEM = ["am", "pm"];

export const FORM_DETAILS = {
  firstName: {
    label: "First Name",
    name: "firstName",
    errorMessage: "Please enter a first name.",
  },
  lastName: {
    label: "Last Name",
    name: "lastName",
    errorMessage: "Please enter a last name.",
  },
  email: {
    label: "Email",
    name: "email",
    errorMessage:
      "Please enter an email. After editing an email, you must log out and log back in with the new email address.",
    help: "After editing an email, you must log out and log back in with the new email address.",
  },
  phone: {
    label: "Mobile",
    name: "phone",
    errorMessage: "Please enter a mobile number.",
  },
  workplacePhone: {
    label: "Landline",
    name: "workplacePhone",
    errorMessage: "Please enter a valid landline number.",
  },
  designation: {
    label: "Job Title",
    name: "designation",
    errorMessage: "Please enter a designation.",
  },
};
